import { getScrollParent } from "../../../EasyProjectsCommon/getScrollParent";

export const scrollListItemIntoView = (item: HTMLElement) => {
    const parent = getScrollParent(item);
    const parentRect = parent?.getBoundingClientRect();
    const rect = item?.getBoundingClientRect();

    if (rect && parentRect) {
        const scrollTop = getScrollTopForListItemParent({ rect, parentRect, parentScrollTop: parent.scrollTop });
        if (scrollTop != null) {
            parent.scrollTop = scrollTop;
        }
    }
};

export const scrollListItemIntoViewWithFixedPart = (item: HTMLElement, callback?: F) => {
    const parent = getScrollParent(item);
    const parentRect = parent?.getBoundingClientRect();
    const rect = item?.getBoundingClientRect();

    if (rect && parentRect) {
        const fixedPart = parent.querySelector("div.mb-new-message,style[position='fixed']")?.clientHeight || 0;
        const scrollTop = getScrollTopForListItemParent({
            rect,
            parentRect,
            parentScrollTop: parent.scrollTop,
            fixedPart,
        });
        if (scrollTop != null) {
            $(parent).stop().animate({
                scrollTop,
            });
        }
    }
    callback?.();
};

type Args = {
    rect: Partial<DOMRect>;
    parentRect: Partial<DOMRect>;
    parentScrollTop: number;
    fixedPart?: number;
};

const getScrollTopForListItemParent = ({ rect, parentRect, parentScrollTop, fixedPart = 0 }: Args) => {
    const relativeTop = rect.top - parentRect.top;
    const relativeBottom = rect.bottom - parentRect.bottom + fixedPart;
    if (relativeTop < 0) {
        return parentScrollTop + relativeTop;
    } else if (relativeBottom > 0) {
        return parentScrollTop + relativeBottom;
    }

    return null;
};

export const internals = { getScrollTopForListItemParent };
